import React, { useState, useEffect, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import SimpleInput from '../../../components/ReactSimpleInput';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '../../../pages/Searchs/styles.css';
import Select from 'react-select';
import If from '../../../components/If';
import Loading from '../../../components/Loading';
import Button from '../../../components/Button';
import EditButton from '../../../components/EditButton';
import CancelButton from '../../../components/CancelRequisitionButton';
import ViewButton from '../../../components/ViewButton';
import PDFButton from '../../../components/GeneratePDF';
import ZipButton from '../../../components/GenerateZip';
import SearchEmpty from '../../../components/SearchEmpty';
import ReasonModal from '../../../components/ReasonModal';
import { DecodedToken } from '../../../models/user';
import { STRINGS_CADERNOCONFORMIDADE } from '../../../util/cadernoConformidade/string';

import { isAdmin } from '../../../users/CadernoConformidade/isAdmin';
import { isRequesterReader, isRequesterWriter } from '../../../users/CadernoConformidade/isRequester';
import { isReguladorWriter, isReguladorReader } from '../../../users/CadernoConformidade/isRegulador';

import { STATUS_CADERNOCONFORMIDADE } from '../../../util/cadernoConformidade/status';
import jwtDecode from 'jwt-decode';
import api, { apiFileDownload } from '../../../services/api';
import ptBR from 'date-fns/locale/pt-BR';
import { _generateDate } from '../../../util/convert';
import AlertSuccess from '../../../components/AlertSuccess';
import { isOptionDisabled } from 'react-select/src/builtins';
import '../styles_add.scss';

import { VegetacaoById, VegetacaoSearchResult, CultureResult, Enum } from '../../../models/modelsCadernoConformidade';

registerLocale('pt-BR', ptBR);

export default function CadernoConformidade ()
{
	const location = useLocation();
	const history = useHistory();
	const token = String(localStorage.getItem('token'));
	const { roles, unique_name }: DecodedToken = jwtDecode(token);
	const [vegetacoes, setVegetacoes] = useState<VegetacaoSearchResult[]>([]);
	const [cultures, setCultures] = useState<CultureResult[]>([]);
	const [status, setStatus] = useState<Enum[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingSearch, setLoadingSearch] = useState<boolean>(false);
	const [error, setError] = useState<any>(null);
	const [emptySearch, setEmptySearch] = useState<boolean>(false);
	const [isCancel, setIsCancel] = useState<boolean>(false);
	const [reasonCancel, setReasonCancel] = useState('');
	const [loadingCancel, setLoadingCancel] = useState<boolean>(false);
	const [successCancel, setSuccessCancel] = useState<boolean>(false);
	const [cancelError, setCancelError] = useState<any>(null);
	const [tempId, setTempId] = useState<number>(0);

	const { register, handleSubmit, watch, control } = useForm({
		defaultValues: {
			projeto: '',
			solicitante: (isAdmin(roles) || isReguladorReader(roles) || isReguladorWriter(roles)) ? '' : unique_name,
		}
	})

	const getCadernoConformidadeVegetacao = async () => {
		setError(false);
		try {
			let requester = (isAdmin(roles) || isReguladorReader(roles) || isReguladorWriter(roles)) ? '' : unique_name;
			
			const { data } = await api.get<VegetacaoSearchResult[]>(`api/v1/caderno-conformidade/Vegetacao/obterporfiltro?Requisitante=${requester}`);
			setVegetacoes(data);
		} catch (error:any) {
			setError(true);
		}
	}

	useEffect(() => {

		setLoading(true);

	const getData = async () => {
		try {
			const status = await api.get<Enum[]>('api/v1/caderno-conformidade/Enum/status');

			setStatus(Array.isArray(status.data) ? status.data : []);

		} catch (error: any) {

		}

			setLoading(false);
		}

		getData();
		getCadernoConformidadeVegetacao();
	}, [])


	const search = async (queries?: any) => {
		setError(false);
		setLoadingSearch(true);

		try {	
			let requester = queries?.solicitante;
			const { data } = await api.get<VegetacaoSearchResult[]>(`api/v1/caderno-conformidade/Vegetacao/obterporfiltro?Requisitante=${requester}&Status=${queries?.status ? queries.status.value : ''}`);

			if (data.length) {
				setVegetacoes(data);
				setEmptySearch(false);
			} else {
				setEmptySearch(true);
			}
		} catch (error:any) {
			setError(true);
		}
		setLoadingSearch(false);
	}

	const can_edit = (info : string) : boolean =>
	{
		const possuiPerfilAdmin = isAdmin(roles);
		const possuiPerfilRegulador = isReguladorReader(roles) || isReguladorWriter(roles);
		const possuiPerfilRequisitante = isRequesterReader(roles) || isRequesterWriter(roles);

		switch (info)
		{
			case 'filtro_solicitante':

				return possuiPerfilRegulador || possuiPerfilAdmin;
		}

		return true;
	}

	const acoes = ({ data }: any) =>
	{
		const possuiPerfilAdmin = isAdmin(roles);
		const possuiPerfilRegulador = isReguladorReader(roles) || isReguladorWriter(roles);
		const ehRequisitanteDaRequisicao = data.requisitante === unique_name;

		const canEditStatusPerfilRequisitante = [
			STATUS_CADERNOCONFORMIDADE.EmPreenchimento
			, STATUS_CADERNOCONFORMIDADE.CorrecaoSolicitada
			, STATUS_CADERNOCONFORMIDADE.EmCorrecao
			, STATUS_CADERNOCONFORMIDADE.CorrecaoCriacaoSolicitada
			, STATUS_CADERNOCONFORMIDADE.SolicitacaoCriacaoAprovada
		];

		const canEditStatusPerfilRegulador = [
			STATUS_CADERNOCONFORMIDADE.EmAnalisePeloRegulatorio
			, STATUS_CADERNOCONFORMIDADE.SolicitacaoCriacaoEmAnalise
			, STATUS_CADERNOCONFORMIDADE.CorrecaoCriacaoSolicitada
			, STATUS_CADERNOCONFORMIDADE.CorrecaoSolicitada
			, STATUS_CADERNOCONFORMIDADE.EmCorrecao
		];

		let canEdit = false;

		if (possuiPerfilAdmin) {
			canEdit = true;
		} else if ((possuiPerfilRegulador && canEditStatusPerfilRegulador.includes(data.status)) || (possuiPerfilRegulador && ehRequisitanteDaRequisicao)) {
			canEdit = true;
		} else if (ehRequisitanteDaRequisicao && canEditStatusPerfilRequisitante.includes(data.status)) {
			canEdit = true;
		}

		let canCancel = canEdit && data.status !== STATUS_CADERNOCONFORMIDADE.Cancelado;

		if (!possuiPerfilAdmin && !possuiPerfilRegulador) {
			const canCancelPerfilRequisitante = [
				STATUS_CADERNOCONFORMIDADE.EmPreenchimento,
				STATUS_CADERNOCONFORMIDADE.CorrecaoSolicitada,
				STATUS_CADERNOCONFORMIDADE.EmAnalisePeloRegulatorio,
				STATUS_CADERNOCONFORMIDADE.SolicitacaoCriacaoEmAnalise
			];

			canCancel = canCancel && canCancelPerfilRequisitante.includes(data.status);
		}

		return (
			<Fragment>
				{/*<ViewButton onClick={() => {*/}
				{/*	history.push({*/}
				{/*		pathname: '/cadernoconformidade/visualizar/vegetacao',*/}
				{/*		state: {*/}
				{/*			id: data.id*/}
				{/*		}*/}
				{/*	})*/}
				{/*}} />*/}

				<EditButton disable={!canEdit} onClick={() => {
					if (canEdit) {
						var urlEdit;
						if (data.status === STATUS_CADERNOCONFORMIDADE.SolicitacaoCriacaoEmAnalise || data.status === STATUS_CADERNOCONFORMIDADE.CorrecaoCriacaoSolicitada) { 
							urlEdit = '/cadernoconformidade/cadastrar/vegetacao';
						}
						else
						{
							urlEdit = `/cadernoconformidade/editar/vegetacao`;
						}

						history.push({
							pathname: urlEdit,
							state: {
								id: data.id
							}
						})
					}
				}} />

				<PDFButton onClick={() => getPdf(data.id)} />

				<ZipButton Text="Gerar Zip" onClick={() => getZip(data.id)} />

			</Fragment>);
	}

	const getPdf = async (id: number) => {
		try {
			const { data } = await apiFileDownload.get(`api/v1/caderno-conformidade/Relatorios/caderno-conformidade?id=${id}`);

			let blob = new Blob([data], {
				type: 'application/pdf'
			});
			var url = window.URL.createObjectURL(blob)

			let a = document.createElement("a");
			if (typeof a.download === "undefined") {
				window.location.href = url;
			} else {
				a.href = url;
				a.download = location.pathname + `\\Documentos\\Caderno_Conformidade_Vegetacao_${id}`;
				document.body.appendChild(a);
				a.click();
			}
		}
		catch (error: any) {
			console.error(error);
		}
	}


	const getZip = async (id: number) => {
		try {
			const { data } = await apiFileDownload.get(`api/v1/caderno-conformidade/Vegetacao/downloadzip/${id}`);

			let blob = new Blob([data], {
				type: 'application/zip'
			});
			var url = window.URL.createObjectURL(blob)

			let a = document.createElement("a");
			if (typeof a.download === "undefined") {
				window.location.href = url;
			} else {
				a.href = url;
				a.download = `caderno-conformidade-documentos-${id}`;
				document.body.appendChild(a);
				a.click();
			}
		}
		catch (error: any) {
			console.error(error);
		}
	}

//	const getAuthorizationById = async (id: number) => {
//		setLoadingAuthorizationById(true);
//		try {
//			const { data } = await api.get(`api/v1/autorizacoes-cibio/MovimentacaoInterna/${id}`);

//			setAuthorization(data);
//		} catch (error:any) {
//			throw new Error(error);
//		}
//		setLoadingAuthorizationById(false);
//	}

	//const cancelRequisition = async (data: any) => {
	//	setLoadingCancel(true);
	//	setCancelError(null);

	//	try {
	//		const { status } = await api.post('api/v1/caderno-conformidade/Vegetacao/cancelar', {
	//			id: data.id,
	//			requisitante: data.requisitante,
	//			destinatario: data.destinatario,
	//			destinatarioId: data.listaDestinatarioId,
	//			localDestinoPossuiCQB: data.possuiCQB,
	//			origem: data.origem,
	//			objetivoUtilizacao: data.objetivoUtilizacao,
	//			observacoes: data.observacoes,
	//			trechoLPMALocaisMovimentacaoMaterial: data.trechoLPMALocaisMovimentacaoMaterial,
	//			escopoLPMAContemplaMaterial: data.escopoLPMAContemplaMaterial,
	//			embalagemDuplaImpermeavel: data.embalagemDuplaImpermeavel,
	//			identificacaoSimboloRiscoBiologico: data.identificacaoSimboloRiscoBiologico,
	//			responsavelTransporte: data.responsavelTransporte,
	//			dataEnvio: data.dataEnvio,
	//			materialChegouDestinoPerfeitasCondicoes: data.materialChegouDestinoPerfeitasCondicoes,
	//			qtdRecebidaDeAcordoComQtdEnviada: data.qtdRecebidaDeAcordoComQtdEnviada,
	//			responsavelRecebimento: data.responsavelRecebimento,
	//			dataRecebimento: data.dataRecebimento,
	//			culturaId: data.culturaId,
	//			modoTransporteId: data.modoTransporteId,
	//			localPartidaId: data.localPartidaId,
	//			localDestinoId: data.localDestinoId,
	//			eventos: data.eventos,
	//			transportes: data.transportes,
	//			observacoesAnaliseRegulatorio: data.observacoesAnaliseRegulatorio,
	//			motivoCancelamento: reasonCancel
	//		});
	//		if (status === 200) {
	//			setSuccessCancel(true);

	//			setTimeout(() => {
	//				setIsCancel(false);
	//				search();
	//			}, 3000);
	//		}
	//	} catch (error:any) {
	//		setCancelError(error.response.data);
	//	}
	//	setLoadingCancel(false);
	//}

	return <div className="container-custom-search">
		<div className="top-content">
			<h3>{STRINGS_CADERNOCONFORMIDADE.SEARCH_CADERNO_CONFORMIDADE_VEGETACAO}</h3>
		</div>
		<div className="row-buttons">
			<If condition={isAdmin(roles) || isReguladorWriter(roles) || isRequesterWriter(roles)}>
				<Button
					onClick={() => history.push('/cadernoconformidade/cadastrar/vegetacao')}
					contained
					title="Adicionar Caderno de Conformidade"
					type="button"
				/>
			</If>
		</div>
		<br />
		<Form onSubmit={handleSubmit(search)} autoComplete="off">
			<Form.Row>
				<Form.Group as={Col}>
					<Form.Label>Solicitante/Requisitante</Form.Label>
						<Controller
							control={control}
							name="solicitante"      
							render={({ onChange, value }) => (
								<SimpleInput
									defaultValue={value}
									clearButton={can_edit('filtro_solicitante')}
									disabled={!can_edit('filtro_solicitante')}
									className="form-control"
									onChange={onChange}
								/>
							)}
						/>
				</Form.Group>
				<Form.Group as={Col} md={2}>
					<Form.Label>
						Status
					</Form.Label>
					<Controller
						control={control}
						name="status"
					isSearchable={false}
					isClearable
					placeholder=""
					as={<Select options={(status || []).map(stat => Object.assign({ value: stat.key, label: stat.value }))} />}
				/>
				</Form.Group>
				<span className="filter-btn">
					<Button
						title="Buscar"
						type="submit"
						contained
						isLoading={loadingSearch}
					/>
				</span>
			</Form.Row>
		</Form>
		<If condition={emptySearch}>
			<div className="div-empty">
				<SearchEmpty />
			</div>
		</If>
		<If condition={loading}>
			<div className="loading-container">
				<Loading />
			</div>
		</If>
		<If condition={!loading && !error && !emptySearch && vegetacoes.length}>
			<div className="search-content">
				<div className="ag-theme-alpine" style={{ height: "70vh", width: '100%' }}>
					<AgGridReact
						rowData={vegetacoes}
						defaultColDef={{ flex: 1, sortable: true, resizable: true }}
						pagination
						paginationPageSize={10}
						gridOptions={{ headerHeight: 80 }}
						frameworkComponents={{
							actions: acoes,
						}}
					>
						<AgGridColumn
							headerName='Código'
							field='id'
							minWidth={110}
							maxWidth={120}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Requisitante'
							headerClass="myfunc-default-header"
							field='requisitante'
							cellStyle={{
								justifyContent: 'left'
							}}
						/>
						<AgGridColumn
							headerName='Projeto'
							headerClass="myfunc-default-header"
							field='projeto'
						/>
						<AgGridColumn
							headerName='Local'
							headerClass="myfunc-default-header"
							field='municipioNome'
							minWidth={250}
							maxWidth={250}
							cellStyle={{
								justifyContent: 'left'
							}}
						/>
						<AgGridColumn
							headerName='Cultura'
							headerClass="myfunc-default-header"
							field='culturaNome'
							minWidth={150}
							maxWidth={150}
							cellStyle={{
								justifyContent: 'left'
							}}
						/>
						<AgGridColumn
							headerName='Status'
							field='statusDescricao'
							minWidth={400}
							maxWidth={400}
						/>
						<AgGridColumn
							field='Ações'
							cellRenderer='actions'
							minWidth={80}
							maxWidth={100}
						/>
					</AgGridReact>
				</div>
			</div>
		</If>

		{/*<If condition={isCancel}>*/}
		{/*	<ReasonModal*/}
		{/*		show={isCancel}*/}
		{/*		onHide={() => setIsCancel(false)}*/}
		{/*		title={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CANCEL_TITLE}*/}
		{/*		actionMsg="Confirmar"*/}
		{/*		disabled={reasonCancel.length ? false : true}*/}
		{/*		onConfirm={() => {*/}
		{/*			cancelRequisition(authorization);*/}
		{/*		}}*/}
		{/*		loading={loadingCancel}*/}
		{/*		hideFooter={successCancel}*/}
		{/*	>*/}
		{/*		<If condition={loadingAuthorizationById}>*/}
		{/*			<div className="loading-container">*/}
		{/*				<Loading />*/}
		{/*			</div>*/}
		{/*		</If>*/}
		{/*		<If condition={successCancel}>*/}
		{/*			<AlertSuccess*/}
		{/*				message={STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CANCEL_SUCCESS}*/}
		{/*			/>*/}
		{/*		</If>*/}
		{/*		<If condition={!loadingAuthorizationById}>*/}
		{/*			<Form.Label>*/}
		{/*				<strong>{STRINGS_CADERNOCONFORMIDADE.CADERNO_CONFORMIDADE_VEGETACAO_CANCEL_BODY_MSG}</strong>*/}
		{/*			</Form.Label>*/}
		{/*			<Form.Control*/}
		{/*				onChange={({ target }: any) =>*/}
		{/*					setReasonCancel(target.value)*/}
		{/*				}*/}
		{/*				value={reasonCancel}*/}
		{/*				as="textarea"*/}
		{/*				maxLength={200}*/}
		{/*			/>*/}
		{/*		</If>*/}
		{/*	</ReasonModal>*/}
		{/*</If>*/}
	</div>;
}